import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';

import Image from '@plone/volto/components/theme/Image/Image';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { hasBlocksData } from '@plone/volto/helpers/Blocks/Blocks';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';

import { isProfessionalTag } from '../../helpers/blogUtils';
import { homepageImageSources } from '../../helpers/homepageUtils';
import { formatPublicationDate } from '../../helpers/formatPublicationDate';
import { resolveRichTextHtml } from '../../helpers/richTextHtml';

const BlogItemView = (props) => {
  const { content, location } = props;
  const path = getBaseUrl(location?.pathname || '');
  const html = resolveRichTextHtml(content?.text?.data);
  const lead = homepageImageSources(content?.image, {
    minWidth: 800,
    fallback: 'large',
  });

  if (hasBlocksData(content)) {
    return <RenderBlocks {...props} path={path} />;
  }

  return (
    <Container className="view-wrapper csj-blog-item">
      <div className="main-content">
        {lead.src ? (
          <Image
            className="ui image documentImage"
            alt={content.title || ''}
            title={content.title}
            src={lead.src}
            srcSet={lead.srcSet}
            sizes="100vw"
            width={lead.width}
            height={lead.height}
          />
        ) : null}
        {content.effective && (
          <div className="documentCreated">
            {formatPublicationDate(content.effective)}
          </div>
        )}
        {content.title && (
          <h1 className="documentFirstHeading csj-heading1">
            {content.title}
            {content.subtitle && ` - ${content.subtitle}`}
          </h1>
        )}
        {content.description && !isProfessionalTag(content) && (
          <p className="documentDescription">{content.description}</p>
        )}
        {html && (
          <div
            className="documentText"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        )}
      </div>
    </Container>
  );
};

BlogItemView.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired,
  location: PropTypes.objectOf(PropTypes.any),
};

export default BlogItemView;
